/* unplugin-vue-components disabled */import script from "./Play.vue?vue&type=script&setup=true&lang=js"
export * from "./Play.vue?vue&type=script&setup=true&lang=js"

import "./Play.vue?vue&type=style&index=0&id=4d42d9ea&lang=scss&scoped=true"
import "./Play.vue?vue&type=style&index=1&id=4d42d9ea&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d42d9ea"]])

export default __exports__